<template>
      <div id="toTop" @click="toTop" v-if='toshow'><img src="../assets/img/th.png" alt=""></div >    
</template>
<script>
  let timer = null //定义初始值
  export default {
    props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:100
      }
    },
  data(){
    return{
       toshow:false,
    }
  },

    methods:{
      toTop(){ // 动画

         timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop
          let ispeed = Math.floor(-osTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
          this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    },

    created(){
      window.onscroll=()=>{
          var topHeight = window.screen.height
        if (document.documentElement.scrollTop>topHeight){
          this.toshow=true;
        }else {
          this.toshow=false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #toTop{
    height: .5rem;
    width: .5rem;
    position: fixed;
    bottom: 1.3rem;
    right: 2rem;
    border-radius: 50%;
    overflow: hidden;
  }
</style>